import React from "react";
import Header from "./components/header";
import MetricCard from "./components/metricCard";
import { FaDollarSign, FaCopy, FaUsers, FaBuilding } from "react-icons/fa";
import { IconType } from "react-icons";
import metricsData from "../../insightdummyJsonTesting/metricsData.json";
import "../../assets/scss/pages/admin/_insightAdmin.scss";

// Define valid icon keys
type IconKey = "FaDollarSign" | "FaCopy" | "FaUsers" | "FaBuilding";

// Map icons
const iconMap: Record<IconKey, IconType> = {
	FaDollarSign,
	FaCopy,
	FaUsers,
	FaBuilding
};

interface Metric {
	label: string;
	value: string;
	change: string;
	changeText: string;
	icon: IconKey;
	testId: string;
}

export default function Insights() {
	const metrics = (metricsData as Metric[]).map((metric) => ({
		...metric,
		icon: iconMap[metric.icon as IconKey]
	}));

	return (
		<div className="dashboard-container insights-page">
			<Header />
			<div className="container-fluid">
				<div className="container">
					{/* Insights Section */}
					<section className="insights-section">
						<div className="section-header">
							<h1 className="section-title" data-testid="insights-title">
								Insights
							</h1>
							<p className="section-subtitle" data-testid="insights-subtitle">
								At-a-glance metrics for user growth and ARR.
							</p>
						</div>
						{/* Metrics Grid */}
						<div className="row g-3 mb-5" data-testid="metrics-grid">
							{metrics.map((metric, index) => (
								<div key={index} className="col-12 col-sm-6 col-lg-3">
									<MetricCard
										label={metric.label}
										value={metric.value}
										change={metric.change}
										changeText={metric.changeText}
										icon={metric.icon}
										testId={metric.testId}
									/>
								</div>
							))}
						</div>
					</section>

					{/* User Growth Section */}
					<section className="user-growth-section">
						<div className="section-header">
							<h2 className="section-title" data-testid="user-growth-title">
								User Growth
							</h2>
							<p className="section-subtitle" data-testid="user-growth-subtitle">
								A detailed look at user growth over the last 6 months.
							</p>
						</div>
						{/* Chart Container */}
						<div className="chart-section" data-testid="chart-container">
							<div className="chart-placeholder" data-testid="chart-placeholder">
								User Growth Chart Placeholder
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>
	);
}
